require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-deutschkreutz.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-deutschkreutz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-deutschkreutz!./.cache/json/betreuungseinrichtungen-oberpullendorf-deutschkreutz.json
// module id = 971
// module chunks = 231608221292675